'use client';

import { Flex, Text } from '@skin-seoul/design-system';
import { SafeLink } from '@/components/ui/SafeLink';
import { FREE_SHIPPING_BANNER_HEIGHT } from '@/components/layout/Header/constants/css.client';
import { CLASSNAME, getActiveYearEndFlashSaleRotation } from '@skin-seoul/service';
const BANNER_TEXT = 'CYBER WEEK UP TO 50% OFF';
const FreeShippingBanner = () => {
  const activeFlashSale = getActiveYearEndFlashSaleRotation();
  const textContent = <Text color="generic.0" fontWeight="regular" textStyle="paragraph.small" textAlign="center" className={CLASSNAME.NOT_TRANSLATE}>
      {BANNER_TEXT}
    </Text>;
  return <Flex alignItems="center" height={`${FREE_SHIPPING_BANNER_HEIGHT}px`} justifyContent="center" transition="all 0.3s" width="100%" bgGradient="linear-gradient(to right, #B86D00, #000000)" data-sentry-element="Flex" data-sentry-component="FreeShippingBanner" data-sentry-source-file="FreeShippingBanner.tsx">
      {activeFlashSale ? <SafeLink href={activeFlashSale.campaignUrl} unstyled>
          {textContent}
        </SafeLink> : textContent}
    </Flex>;
};
export default FreeShippingBanner;